import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7mpmh7qts: FaireProductEntity = {
  token: "p_m7mpmh7qts",
  type: "product",
  name: "KD-SW-1027 Youth Plaid - Red",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/ea14cec5ea7d52df6e5c8a07d22f8ebc7075a2be1413102d21cd9fd37efe083b.jpeg",
  galleryImageUrls: [],
  priceDollars: 26.5,
  description: "This youth plaid sweatshirt in red offers a lively, casual look designed for wear. Girlie Girl Originals brings a comfortable, playful aesthetic suited for youngsters, combining easy layering with a spirited pattern that complements a variety of outfits.",
  tags: [],
  msrpDollars: 53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:12.672Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
